import React, { useState } from 'react'
import {
    StepFormContainer,
    StyledQuestionText,
    StyledTextField,
} from '../../styles/Forms/StepsForm.style';
import { Step3FormQuestions } from '../../enums/page_texts/contact_forms_texts';
import { Box, InputAdornment, MenuItem, useMediaQuery, useTheme } from '@mui/material';
import { CalendarToday, LocationOn } from '@mui/icons-material';
import HoursPicker from './HoursPicker';

interface Step3FormProps {
    formData: {
        venueAddress: string; //UPDATE TYPE
        eventDate: string; //UPDATE TYPE
        isDateFlexible: boolean;
        startHour: string;
        endHour: string;
        otherInformation: string;
    };
    handleChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    errors: {
        venueAddress?: string; //UPDATE TYPE
        eventDate?: string; //UPDATE TYPE
        isDateFlexible?: string;
        startHour?: string;
        endHour?: string;
    };
}

const Step3Form: React.FC<Step3FormProps> = ({ formData, handleChange, errors }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const [otherInformation, setOtherInformation] = useState(formData.otherInformation || '')

    const handleOtherInformationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOtherInformation(event.target.value);
        handleChange({
            ...event,
            target: {
                ...event.target,
                name: 'otherInformationType',
                value: event.target.value,
            },
        })
    }

    return (
        <StepFormContainer>

            {/* Row 1: Address + Date */}
            <Box sx={isDesktop ? { display: 'flex', gap: 3, alignItems: 'flex-start' } : undefined}>
                <Box sx={{ flex: 1 }}>
                    <StyledQuestionText>
                        {Step3FormQuestions.Question1}
                    </StyledQuestionText>
                    <StyledTextField
                        label="Adresse de l'événement"
                        name="venueAddress"
                        value={formData.venueAddress}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        error={!!errors.venueAddress}
                        helperText={errors.venueAddress}
                        sx={isDesktop ? { maxWidth: '100%', minWidth: '100%' } : undefined}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LocationOn sx={{color: 'white'}}/>
                                    </InputAdornment>
                                ),
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }}
                    />
                </Box>

                <Box sx={{ flex: 1 }}>
                    <StyledQuestionText>
                        {Step3FormQuestions.Question2}
                    </StyledQuestionText>
                    <StyledTextField
                        label="Date de l'événement"
                        type="date"
                        name="eventDate"
                        value={formData.eventDate}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        error={!!errors.eventDate}
                        helperText={errors.eventDate}
                        sx={isDesktop ? { maxWidth: '100%', minWidth: '100%' } : undefined}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <CalendarToday sx={{color: 'white'}} />
                                    </InputAdornment>
                                ),
                            },
                            inputLabel: {
                                shrink: true
                            },
                        }}
                    />
                </Box>
            </Box>

            {/* Row 2: Date flexible + Hours */}
            <Box sx={isDesktop ? { display: 'flex', gap: 3, alignItems: 'flex-end' } : undefined}>
                <Box sx={isDesktop ? { flex: '0 0 200px' } : undefined}>
                    <StyledQuestionText>
                        {Step3FormQuestions.Question3}
                    </StyledQuestionText>
                    <StyledTextField
                        select
                        fullWidth
                        label="Date flexible?"
                        name="isDateFlexible"
                        value={formData.isDateFlexible}
                        onChange={handleChange}
                        margin="normal"
                        error={!!errors.isDateFlexible}
                        helperText={errors.isDateFlexible}
                        sx={isDesktop ? { maxWidth: '200px', minWidth: '200px' } : undefined}
                    >
                        <MenuItem value='Oui'>Oui</MenuItem>
                        <MenuItem value='Non'>Non</MenuItem>
                    </StyledTextField>
                </Box>

                <Box sx={{ flex: 1 }}>
                    <StyledQuestionText>
                        {Step3FormQuestions.Question4}
                    </StyledQuestionText>
                    <HoursPicker formData={formData} handleChange={handleChange} errors={errors} />
                </Box>
            </Box>

            {/* Other information */}
            <StyledQuestionText>
                {Step3FormQuestions.Question5}
            </StyledQuestionText>
            <StyledTextField
                name="otherMaterial"
                value={otherInformation}
                onChange={handleOtherInformationChange}
                placeholder="Veuillez préciser"
                fullWidth
                margin="normal"
                sx={isDesktop ? { maxWidth: '100%', minWidth: '100%' } : undefined}
            />

        </StepFormContainer>
    )
}

export default Step3Form